import { Box, IconButton, Tooltip } from "@compass/core";
import AutoStoriesSharpIcon from "@mui/icons-material/AutoStoriesSharp";
import { useNavigate } from "react-router-dom";
import { userManualPageRoute } from "../../../pages/UserManual/UserManualPage";


export const AppTopBarManual = () => {
    const navigate = useNavigate();

    return (
        <Box>
            <Tooltip title="User Manual">
                <IconButton
                    onClick={() => navigate(`/${userManualPageRoute.getPath()}`)}
                    aria-label="Open User Manual"
                    size="large"
                >
                    <AutoStoriesSharpIcon sx={{ fontSize: 34 }} />
                </IconButton>
            </Tooltip>
        </Box>
    );
};